import React from "react";
import { useLocation } from "react-router-dom";
import { PublicHeader } from "../Components/Public/PublicHeader";
import { PublicFooter } from "../Components/Public/PublicFooter";
import { paths } from "../Constant/paths";

const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();
  const noHeaderFooterPaths = [
    paths.login,
    paths.registration,
    paths.verifyEmail,
    paths.forgetPassword,
    paths.resetPassword,
  ];

  return (
    <main className="main p-0">
      <div className="login-wrapper w-100 h-100">
        {!noHeaderFooterPaths.includes(`/${pathname.split("/")?.[1]}`) && (
          <PublicHeader />
        )}
        {children}
        {!noHeaderFooterPaths.includes(`/${pathname.split("/")?.[1]}`) && (
          <PublicFooter />
        )}
      </div>
    </main>
  );
};

export default PublicLayout;
